export const sections = [
    {
        type: "Saxophones",
        instruments: [
            { name: 'Soprano sax (Bb)', clean: 'soprano_sax_bb', key: 'Bb' },
            { name: 'Alto sax (Eb)', clean: 'alto_sax_eb', key: 'Eb' },
            { name: 'Tenor sax (Bb)', clean: 'tenor_sax_bb', key: 'Bb' },
            { name: 'Baritone sax (Eb)', clean: 'baritone_sax_eb', key: 'Eb' }
        ],
    }, {
        type: "Other woodwinds",
        instruments: [
            { name: 'Clarinet (Bb)', clean: 'clarinet_bb', key: 'Bb' },
            { name: 'Flute', clean: 'flute', key: 'C' }
        ]
    }, {
        type: "Brass instruments",
        instruments: [
            { name: 'Trombone', clean: 'trombone', key: 'C-bass' }, 
            { name: 'Trumpet (Bb)', clean: 'trumpet_bb', key: 'Bb' },
            { name: 'Tuba', clean: 'tuba', key: 'C-bass' }, 
            { name: 'Baritone horn', clean: 'baritone_horn', key: 'C-bass' } 
        ]
    }, {
        type: "Rhythm instruments",
        instruments: [
            { name: 'Bass', clean: 'bass', key: 'Bass' },
            { name: 'Drums', clean: 'drums', key: 'Drums' }, 
            { name: 'Guitar', clean: 'guitar', key: 'Guitar' }, 
            { name: 'Piano', clean: 'piano', key: 'Piano' }
        ]
    }, {
        type: "Strings",
        instruments: [
            { name: 'Violin/Viola', clean: 'violin_viola', key: 'C' }, 
            { name: 'Cello', clean: 'cello', key: 'C-bass' }, //TODO: did this work?
            // { name: 'Voice', clean: 'voice', key: 'C' } 
        ]
    }
];

export const instruments = sections.map(group => group.instruments).reduce((p, c) => [...p, ...c]);

export const levels = [ //name songs changed to levels
    {
        type: "Level 1",
        songs: [
            { name: 'Dorian\'s Lament', clean: 'dorians_lament' },
        ],
    }, {
        type: "Level 2",
        songs: [
            { name: 'Song For My Father', clean: 'song_for_my_father' },
            { name: 'Blues By Five', clean: 'blues_by_five' }
        ]
    }, {
        type: "Level 3",
        songs: [
            { name: 'Mr. PC', clean: 'mr_pc' },
            { name: 'Big Bertha', clean: 'big_bertha' }
        ]
    }, {
        type: "Level 4",
        songs: [
            { name: 'Jeannine', clean: 'jeannine' },
            { name: 'Yardbird Suite', clean: 'yardbird_suite' }
        ]
    }, {
        type: "Level 5",
        songs: [
            { name: 'Whisper Not', clean: 'whisper_not' },
            { name: 'Fantasy in D', clean: 'fantasy_in_d' },
        ]
    }
];

export const songs = levels.map(group => group.songs).reduce((p, c) => [...p, ...c]);

export const parts = [
    { name: 'Practice Track', clean: 'Practice-Track'},
    { name: 'Practice Drums', clean: 'Practice-Drums'},
    { name: 'Practice Bass', clean: 'Practice-Bass'},
    { name: 'Practice Piano/Guitar', clean: 'Practice-Piano-Guitar'},
    { name: 'Drums', clean: 'Drums', scoreAlias: 'Part_1' },
    { name: 'Bass', clean: 'Bass', scoreAlias: 'Part_1' },
    { name: 'Piano/Guitar', clean: 'Piano-Guitar', scoreAlias: 'Part_1' },
    { name: 'Part 1 melody', clean: 'Melody' },
]
